// src/pages/StokTakip.js
import React, { useState, useEffect } from 'react';
import './StokTakip.css';

const API_URL = "/api/stok";

const StokTakip = () => {
  const [stoklar, setStoklar] = useState([]);
  const [loglar, setLoglar] = useState([]);
  const [yeniParca, setYeniParca] = useState({
    ad: '',
    parcaKodu: '',
    ozellik: '',
    stok: '',
    birim: '',
    minStok: ''
  });
  const [arama, setArama] = useState('');
  const [duzenlenenId, setDuzenlenenId] = useState(null);
  const [duzenleParca, setDuzenleParca] = useState({});
  
  // Backend'den verileri çek
  useEffect(() => {
    fetch(API_URL)
      .then(res => res.json())
      .then(data => setStoklar(data))
      .catch(err => console.error("Veri alınamadı:", err));
  }, []);

  // Yeni parça ekle
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setYeniParca((prev) => ({ ...prev, [name]: value }));
  };

  const parcaEkle = () => {
    if (!yeniParca.ad || !yeniParca.stok || !yeniParca.minStok || !yeniParca.parcaKodu) return;

    const yeni = {
      ...yeniParca,
      stok: parseInt(yeniParca.stok),
      minStok: parseInt(yeniParca.minStok),
    };

    fetch(API_URL, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(yeni)
    })
      .then(() => {
        fetch(API_URL)
          .then(res => res.json())
          .then(data => setStoklar(data));
        logEkle(`🟢 ${yeni.ad} eklendi (${yeni.stok} ${yeni.birim})`);
        setYeniParca({ ad: '', parcaKodu: '', ozellik: '', stok: '', birim: '', minStok: '' });
      })
      .catch(err => console.error("Kayıt hatası:", err));
  };

  const logEkle = (mesaj) => {
    const zaman = new Date().toLocaleString('tr-TR');
    setLoglar(prev => [{ mesaj, zaman }, ...prev]);
  };

  // Stok artır/azalt işlemleri
  const stokArtir = (id) => {
    const parca = stoklar.find(p => p.id === id);
    if (!parca) return;

    const guncel = { ...parca, stok: parca.stok + 1 };
    fetch(`${API_URL}/${id}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(guncel)
    })
      .then(() => {
        setStoklar(stoklar.map(p => p.id === id ? guncel : p));
        logEkle(`➕ ${parca.ad} stok +1 (yeni: ${guncel.stok})`);
      });
  };

  const stokAzalt = (id) => {
    const parca = stoklar.find(p => p.id === id);
    if (!parca || parca.stok <= 0) return;

    const guncel = { ...parca, stok: parca.stok - 1 };
    fetch(`${API_URL}/${id}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(guncel)
    })
      .then(() => {
        setStoklar(stoklar.map(p => p.id === id ? guncel : p));
        logEkle(`➖ ${parca.ad} stok -1 (yeni: ${guncel.stok})`);
      });
  };

  // Parça sil
  const parcaSil = (id) => {
    const silinen = stoklar.find(p => p.id === id);
    if (silinen && window.confirm(`'${silinen.ad}' adlı parçayı silmek istiyor musunuz?`)) {
      fetch(`${API_URL}/${id}`, { method: "DELETE" })
        .then(() => {
          setStoklar(prev => prev.filter(p => p.id !== id));
          logEkle(`❌ ${silinen.ad} silindi.`);
        })
        .catch(err => console.error("Silme hatası:", err));
    }
  };

  // Parça düzenle başlangıcı
  const parcaDuzenle = (parca) => {
    setDuzenlenenId(parca.id);
    setDuzenleParca({
      ...parca,
      stok: parca.stok.toString(),
      minStok: parca.minStok.toString()
    });
  };

  const handleDuzenleChange = (e) => {
    const { name, value } = e.target;
    setDuzenleParca((prev) => ({ ...prev, [name]: value }));
  };

  const kaydetGuncelle = () => {
    const guncel = {
      ...duzenleParca,
      stok: parseInt(duzenleParca.stok),
      minStok: parseInt(duzenleParca.minStok),
    };

    fetch(`${API_URL}/${duzenlenenId}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(guncel)
    })
      .then(() => {
        setStoklar(stoklar.map(p => p.id === duzenlenenId ? guncel : p));
        logEkle(`✏️ ${guncel.ad} bilgisi güncellendi.`);
        setDuzenlenenId(null);
      })
      .catch(err => console.error("Güncelleme hatası:", err));
  };

  // Arama işlemi
  const filtrelenmisStoklar = stoklar.filter((p) =>
    p.ad.toLowerCase().includes(arama.toLowerCase()) ||
    p.parcaKodu.toLowerCase().includes(arama.toLowerCase())
  );

  return (
    <div className="stok-container">
      {/* PARÇA EKLEME PANELİ */}
      <div className="stok-panel">
        <h2 className="stok-baslik">➕ Parça Ekle / Güncelle</h2>
        <div className="form-grup">
          <input
            name="ad"
            value={yeniParca.ad}
            onChange={handleInputChange}
            className="parca-form"
            placeholder="Parça Adı"
          />
          <input
            name="parcaKodu"
            value={yeniParca.parcaKodu}
            onChange={handleInputChange}
            className="parca-form"
            placeholder="Parça Kodu"
          />
          <input
            name="ozellik"
            value={yeniParca.ozellik}
            onChange={handleInputChange}
            className="parca-form"
            placeholder="Özellik (opsiyonel)"
          />
          <input
            name="stok"
            type="number"
            value={yeniParca.stok}
            onChange={handleInputChange}
            className="parca-form"
            placeholder="Stok"
          />
          <input
            name="birim"
            value={yeniParca.birim}
            onChange={handleInputChange}
            className="parca-form"
            placeholder="Birim"
          />
          <input
            name="minStok"
            type="number"
            value={yeniParca.minStok}
            onChange={handleInputChange}
            className="parca-form"
            placeholder="Min. Stok"
          />
        </div>
        <button onClick={parcaEkle} className="stok-butonu kaydet">💾 Kaydet</button>
      </div>

      {/* STOK LİSTESİ */}
      <div className="stok-panel">
        <h3 className="stok-baslik">📋 Stok Listesi</h3>
        <input
          type="text"
          placeholder="🔍 Parça adı ya da kodu ile ara..."
          value={arama}
          onChange={(e) => setArama(e.target.value)}
          className="parca-form mb-4 w-full"
        />

        <table className="stok-tablo">
          <thead>
            <tr>
              <th>Parça Adı</th>
              <th>Parça Kodu</th>
              <th>Özellik</th>
              <th>Stok</th>
              <th>Min. Stok</th>
              <th>Durum</th>
              <th>İşlem</th>
            </tr>
          </thead>
          <tbody>
            {filtrelenmisStoklar.length > 0 ? (
              filtrelenmisStoklar.map((parca) => (
                <tr key={parca.id}>
                  <td>{parca.ad}</td>
                  <td>{parca.parcaKodu}</td>
                  <td>{parca.ozellik || '-'}</td>
                  <td>{parca.stok}</td>
                  <td>{parca.minStok}</td>
                  <td>
                    {parca.stok < parca.minStok ? (
                      <span className="stok-durum kritik">⚠️ Azaldı</span>
                    ) : (
                      <span className="stok-durum iyi">✔️ Yeterli</span>
                    )}
                  </td>
                  <td>
                    <button onClick={() => stokArtir(parca.id)} className="stok-butonu artir">+</button>
                    <button onClick={() => stokAzalt(parca.id)} className="stok-butonu azalt">-</button>
                    <button onClick={() => parcaDuzenle(parca)} className="stok-butonu duzenle">✏️</button>
                    <button onClick={() => parcaSil(parca.id)} className="stok-butonu sil">🗑️</button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="7">Arama sonucu eşleşen parça bulunamadı.</td>
              </tr>
            )}
          </tbody>
        </table>

        {/* Düzenleme Modülü */}
        {duzenlenenId && (
          <div className="duzenleme-kutusu">
            <h4>✏️ Düzenleme: {duzenleParca.ad}</h4>
            <div className="form-grup">
              <input name="ad" value={duzenleParca.ad} onChange={handleDuzenleChange} className="parca-form" />
              <input name="parcaKodu" value={duzenleParca.parcaKodu} onChange={handleDuzenleChange} className="parca-form" />
              <input name="ozellik" value={duzenleParca.ozellik} onChange={handleDuzenleChange} className="parca-form" />
              <input name="stok" type="number" value={duzenleParca.stok} onChange={handleDuzenleChange} className="parca-form" />
              <input name="birim" value={duzenleParca.birim} onChange={handleDuzenleChange} className="parca-form" />
              <input name="minStok" type="number" value={duzenleParca.minStok} onChange={handleDuzenleChange} className="parca-form" />
            </div>
            <button onClick={kaydetGuncelle} className="stok-butonu kaydet mt-2">💾 Kaydet</button>
          </div>
        )}
      </div>

      {/* HAREKET GEÇMİŞİ */}
      <div className="stok-panel">
        <h3 className="stok-baslik">📝 Hareket Geçmişi</h3>
        <div className="log-kutusu">
          {loglar.map((log, i) => (
            <div key={i} className="log-satiri">
              <span>{log.mesaj}</span>
              <span className="log-tarih">{log.zaman}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default StokTakip;